import type { ConsultationDocument } from '@/types/consultation';

/** Only a transient member storage failure blocks complete archive admission. */
export function needsArchiveRepair(document?: ConsultationDocument): boolean {
  return Boolean(document?.material_manifest?.some(member => member.status === 'failed'
    && member.error === 'document_storage_unavailable'));
}
